
export enum E_PAGE_TYPE {
  HOME = 'home',
  CONTENT = 'content'
}

export enum E_CONTENT_TYPE {
  HEADER = 'header',
  LIST = 'list',
  TWO_COLUMNS = 'two_columns',
  SLIDER = 'slider'
}
